/** 快讯预置关键词（长词优先匹配） */
export const NEWS_KEYWORD_GROUPS: Record<string, string[]> = {
  coins: [
    '比特币', '以太坊', '索拉纳',
    'BTC', 'ETH', 'SOL', 'BNB', 'XRP', 'DOGE', 'ADA', 'AVAX', 'LINK', 'HYPE', 'ZEC',
    'USDT', 'USDC', '稳定币',
  ],
  exchanges: [
    '币安', '欧意', '火币', '芝麻开门',
    'Binance', 'OKX', 'Coinbase', 'Bybit', 'Bitget', 'Hyperliquid', 'Kraken', 'Gate',
  ],
  institutions: [
    '贝莱德', '摩根士丹利', '高盛', '灰度', '富达',
    'BlackRock', 'Strategy', 'MicroStrategy', 'Saylor', 'CZ', 'Vitalik', 'Cathie Wood',
    'ETF', '现货ETF', '比特币ETF',
  ],
  market: [
    '爆仓', '清算', '增持', '减持', '融资', 'IPO', '上市', '减持', '回购',
    '监管', '立法', 'SEC', 'CFTC', '美联储', '降息', '加息', '特朗普', '关税',
    '未实现盈亏', '资金费率', '永续', '合约', '现货',
  ],
  sectors: [
    'DeFi', 'RWA', 'Layer2', 'L2', '质押', '空投', '挖矿',
    '预测市场', 'Polymarket', 'Kalshi', 'AI', '人工智能', 'Meme', 'NFT', 'Web3',
    '稳定币法案', '代币化', '国库', 'DAT',
  ],
}

function uniqueSorted(keywords: string[]): string[] {
  const seen = new Set<string>()
  const out: string[] = []
  for (const kw of keywords) {
    const k = kw.trim()
    if (!k || seen.has(k.toLowerCase())) continue
    seen.add(k.toLowerCase())
    out.push(k)
  }
  return out.sort((a, b) => b.length - a.length)
}

export const NEWS_KEYWORDS: string[] = uniqueSorted(
  Object.values(NEWS_KEYWORD_GROUPS).flat(),
)

export function buildHighlightPattern(keywords: string[]): RegExp | null {
  const list = uniqueSorted(keywords.filter((k) => k.trim()))
  if (!list.length) return null
  const escaped = list.map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  return new RegExp(`(${escaped.join('|')})`, 'gi')
}
